import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getMessagePrograms = api(async function getMessagePrograms({ language, namespaces }) {
    return query(
        gql`
            query GetMessagePrograms($language: String!, $namespaces: [String!]) {
                getMessagePrograms(language: $language, namespaces: $namespaces)
            }
        `,
        { language, namespaces: namespaces ?? ["core"] },
        { returns: "getMessagePrograms" }
    )
})
